import API from './api'

export const getDocuments = async token => {
	const response = await API.get('/api/v1/documents/all', {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	})
	return response.data
}

export const getDocumentById = async (documentId, token) => {
	const response = await API.get(`/api/v1/documents/${documentId}`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	})
	return response.data
}


export const deleteDocumentsServer = async (documentIds, token) => {
    const response = await API.delete('/api/v1/documents/delete', {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: documentIds, // <-- правильно передаём тело
    })
    return response.data
}

export const getBlankDocument = async token => {
	// Системный документ чистого листа A4 — создаётся лениво на бэкенде при
	// первом обращении, дальше всегда возвращается один и тот же id.
	const response = await API.get('/api/v1/documents/blank', {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	})
	return response.data
}

export const getManyDocumentsByIds = async (documentIds, token) => {
    const response = await API.post('/api/v1/documents/batch', 
        { ids: documentIds }, 
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
    return response.data;
};
